import { Popper, Paper, ClickAwayListener, type PopperProps, type PaperProps } from "@mui/material";
import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material/styles";

// Undestructured props are forwarded to MUI's `Popper` via `...rest`, so `PopperProps`
// is the base. `minWidth`/`maxHeight` accept numbers because callers pass raw pixels.
interface PopperComponentProps extends Omit<PopperProps, "children"> {
  onClose: () => void;
  children?: ReactNode;
  zIndex?: number;
  minWidth?: string | number;
  maxHeight?: string | number;
  fontFamily?: string;
  paperSx?: SxProps<Theme>;
  paperProps?: PaperProps;
}

function PopperComponent({
  open,
  anchorEl,
  onClose,
  children,
  zIndex = 1400,
  minWidth = "11.25rem",
  maxHeight = "18.75rem",
  fontFamily = "inherit",
  paperSx = {},
  paperProps = {},
  ...rest
}: PopperComponentProps) {
  return (
    <Popper open={open} anchorEl={anchorEl} style={{ zIndex }} {...rest}>
      <ClickAwayListener onClickAway={onClose}>
        <Paper
          onMouseLeave={onClose}
          sx={
            {
              border: "1px solid #ECF3FE",
              backgroundColor: "#FFFFFF",
              boxShadow: "0.25rem 0.25rem 0.9375rem rgba(65, 92, 171, 0.15)",
              minWidth,
              maxHeight,
              overflowY: "auto",
              fontFamily,
              "& *": { fontFamily: "inherit" },
              ...paperSx,
            } as SxProps<Theme>
          }
          {...paperProps}
        >
          {children}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
}

export default PopperComponent;
